import { render, staticRenderFns } from "./VerifyOrderDialog.vue?vue&type=template&id=2160788a&scoped=true"
import script from "./VerifyOrderDialog.vue?vue&type=script&lang=js"
export * from "./VerifyOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./VerifyOrderDialog.vue?vue&type=style&index=0&id=2160788a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2160788a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2160788a')) {
      api.createRecord('2160788a', component.options)
    } else {
      api.reload('2160788a', component.options)
    }
    module.hot.accept("./VerifyOrderDialog.vue?vue&type=template&id=2160788a&scoped=true", function () {
      api.rerender('2160788a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/tgOrderList/components/VerifyOrderDialog.vue"
export default component.exports